const commonMfAppRuntimeEnvKeys = [
  // 앱 메타데이터
  "APP_NAME",
  "STAGE",
  // 애플리케이션 관련
  "SUBSCRIPTION_FEATURE_KEY_FALLBACK",
  // *이거 전부에 필요한가? GNB에만 있으면 되는거아닌가?
  // 각종 리소스들의 Host
  "API_ENDPOINT",
  "API_ENDPOINT_INTERNAL",
  "ASSET_PREFIX_CF_CNAME",
  "WEB_SOCKET_ENDPOINT",
  // 요거 아직 필요한가?
  "NEXT_PUBLIC_STATIC_FILE_HOST",
  // *런타임으로 전환 필요 + 이름도 바꿀 필요 있음
  // 써드파티 - amplitude
  "AMPLITUDE_API_KEY",
  "AMPLITUDE_SERVER_URL",
  // 써드파티 - GTM
  "EVENT_TRACKING_ENDPOINT",
  "GTM_ID",
  // 써드파티 - sentry
  "NEXT_PUBLIC_SENTRY_RELEASE",
  // version id 등으로 이름 바꾸면 좋을듯
  "SENTRY_DSN",
  // *런타임으로 전환 필요
  "SENTRY_SAMPLE_RATE",
  // 웹 푸시 관련
  "FIREBASE_API_KEY",
  "FIREBASE_APP_ID",
  "FIREBASE_MESSAGING_SENDER_ID",
  "FIREBASE_PROJECT_ID",
  // 모바일 앱 관련
  "ANDROID_APP_PACKAGE_ID",
  "IOS_APP_BUNDLE_ID",
  "IOS_APP_ITUNES_ID",
  "MOBILE_APP_SCHEME",
  // 서버 제어 용도(클라이언트와 무관)
  "GRACEFUL_SHUTDOWN_PERIOD_SECONDS"
];
const commonNextAppRuntimeEnvKeys = [
  // 앱 메타데이터
  "APP_NAME",
  "STAGE",
  // 각종 리소스들의 Host
  "API_ENDPOINT",
  "API_ENDPOINT_INTERNAL",
  "ASSET_PREFIX_CF_CNAME",
  "WEB_SOCKET_ENDPOINT",
  // 요거 아직 필요한가?
  "NEXT_PUBLIC_STATIC_FILE_HOST",
  // *런타임으로 전환 필요 + 이름도 바꿀 필요 있음
  // 써드파티 - amplitude
  "AMPLITUDE_API_KEY",
  "AMPLITUDE_SERVER_URL",
  // 써드파티 - GTM
  "EVENT_TRACKING_ENDPOINT",
  "GTM_ID",
  // 써드파티 - sentry
  "NEXT_PUBLIC_SENTRY_RELEASE",
  // version id 등으로 이름 바꾸면 좋을듯
  "SENTRY_DSN",
  // *런타임으로 전환 필요
  // 웹 푸시 관련
  "FIREBASE_API_KEY",
  "FIREBASE_APP_ID",
  "FIREBASE_MESSAGING_SENDER_ID",
  "FIREBASE_PROJECT_ID",
  // 모바일 앱 관련
  "ANDROID_APP_PACKAGE_ID",
  "IOS_APP_BUNDLE_ID",
  "IOS_APP_ITUNES_ID",
  "MOBILE_APP_SCHEME"
];
const remoteRecruitingRuntimeEnvKeys = [
  // 애플리케이션 관련
  "RECRUITING_SITE_ROOT_DOMAIN"
];
const widgetGlobalFeaturesRuntimeEnvKeys = [
  // 애플리케이션 관련
  "HELP_CENTER_STATIC_URL"
];
const remoteMiniAppsRuntimeEnvKeys = [
  // 애플리케이션 관련
  "IT_ASSET_PUBLIC_SITE_ENDPOINT"
];
const remoteFinsAppsRuntimeEnvKeys = [
  // 인증서 서명시 사용할 원문
  "FINS_CERTIFICATE_SIGN_DOCUMENT_KEY",
  // 인증서 클라이언트로부터 pfx/pwd값 추출시 서명에 사용할 public key
  "FINS_CERTIFICATE_PFX_EXTRACT_PUBLIC_KEY"
];
const authRuntimeEnvKeys = [
  // 애플리케이션 관련
  "SAML_VERIFICATION_ORIGIN"
];
const publicRecruitingRuntimeEnvKeys = [
  // 애플리케이션 관련
  "RECRUITING_SITE_ROOT_DOMAIN",
  "FLEX_APP_URL"
];
const publicCareersTeamRuntimeEnvKeys = [
  // 애플리케이션 관련
  "RECRUITING_SITE_ROOT_DOMAIN"
];
const runtimeEnvKeys = [
  ...commonMfAppRuntimeEnvKeys,
  ...commonNextAppRuntimeEnvKeys,
  ...remoteRecruitingRuntimeEnvKeys,
  ...widgetGlobalFeaturesRuntimeEnvKeys,
  ...remoteMiniAppsRuntimeEnvKeys,
  ...remoteFinsAppsRuntimeEnvKeys,
  ...authRuntimeEnvKeys,
  ...publicRecruitingRuntimeEnvKeys
];

export { authRuntimeEnvKeys, commonMfAppRuntimeEnvKeys, commonNextAppRuntimeEnvKeys, publicCareersTeamRuntimeEnvKeys, publicRecruitingRuntimeEnvKeys, remoteFinsAppsRuntimeEnvKeys, remoteMiniAppsRuntimeEnvKeys, remoteRecruitingRuntimeEnvKeys, runtimeEnvKeys, widgetGlobalFeaturesRuntimeEnvKeys };
//# sourceMappingURL=runtime.mjs.map
